import { useReactiveVar } from "@apollo/client";
import { useMemo } from "react";
import * as Styled from "./style";
import { PortalModal } from "~/components/blocks/common/portal-modal";
import { isOpenReviewModalVar } from "~/components/stores/detail-product/store";
import { useHandleClickByDevice } from "~/hooks/use-handle-click-by-device";
import { useMatchMedia } from "~/hooks/use-match-media";
import { Z_INDEX } from "~/styles/z-index";

/**
 * 運営チームがレビュー内容を確認しているステータスの時に表示するモーダル
 * - 運営チームがレビュー内容を確認中 = Review.isConfirmed が true
 */
export const ConfirmReviewModal = () => {
  const isOpenReviewModal = useReactiveVar(isOpenReviewModalVar);

  const { handleClickByDevice } = useHandleClickByDevice();
  const { isSpSize } = useMatchMedia();

  const modalSize = useMemo(() => (!isSpSize ? "middle" : "fullScreen"), [isSpSize]);

  return (
    <PortalModal
      size={modalSize}
      basisZIndex={Z_INDEX.MODAL_IN_MODAL}
      isOpen={isOpenReviewModal}
      onCloseModal={() => isOpenReviewModalVar(false)}
      headerConfig={{
        isShow: true,
        headerTitle: <Styled.Heading>この作品のレビューはスタッフ確認中です</Styled.Heading>,
      }}
    >
      <Styled.DivRootFlexContainer>
        <section>
          <Styled.ParText>レビュー公開までしばらくお待ちください。</Styled.ParText>

          <Styled.UlNavList>
            <li>通常一週間ほどで公開されますが、それ以上かかることがあります。</li>
            <li>レビュー利用規約に反する場合は、公開されないことがあります。</li>
          </Styled.UlNavList>
        </section>

        <Styled.DivFlexCenter>
          <Styled.CloseButton
            name="Modalを閉じるボタン"
            mainText="閉じる"
            {...handleClickByDevice(() => isOpenReviewModalVar(false))}
          />
        </Styled.DivFlexCenter>
      </Styled.DivRootFlexContainer>
    </PortalModal>
  );
};
